import { render, staticRenderFns } from "./CertFront.vue?vue&type=template&id=3c157b2a&"
import script from "./CertFront.vue?vue&type=script&lang=js&"
export * from "./CertFront.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports